import { useState } from 'react'
import { Tabs, TabsContent } from '@/components/ui/tabs'
import { Card } from '@/components/ui/card'
import { UnderlinedTabsList } from '@/components/atoms/UnderlinedTabsList'

import {
  OrderCustomerInfo,
  OrderDetailHeader,
  OrderItemsTable,
  OrderPaymentInfo,
  OrderStatusCard,
  OrderTimeline,
  OrderShippingAddress,
  OrderInvoice,
} from '@/components/features/orders/detail'
import { useOrderDetail } from '@/hooks/features/orders'
import { Spinner } from '@/components/ui/spinner'

export const OrderDetail = () => {
  const { order, loading, navigate, actions, refresh } = useOrderDetail()
  const [showInvoice, setShowInvoice] = useState(false)

  if (loading && !order) {
    return (
      <div className="flex items-center justify-center p-8">
        <Spinner className="size-6 text-muted-foreground" />
      </div>
    )
  }

  if (!order) {
    return <div className="p-8 text-center text-sm text-muted-foreground">Order not found</div>
  }

  const tabs = [
    { label: 'Items', value: 'items' },
    { label: 'Timeline', value: 'timeline' },
  ]

  const isEditable = order.status === 'active' || order.status === 'ready_to_ship'

  return (
    <div className="mx-auto w-full max-w-[1088px] pb-10">
      <OrderDetailHeader
        orderRef={order.order_ref}
        createdAt={order.created_at}
        status={order.status}
        onBack={() => navigate('/orders')}
        isEditable={isEditable}
        onPrint={() => setShowInvoice(true)}
      />

      <OrderInvoice open={showInvoice} onClose={() => setShowInvoice(false)} order={order} />

      <div className="grid items-start gap-4 lg:grid-cols-[minmax(0,1fr)_288px] lg:gap-6">
        <div className="min-w-0 space-y-4">
          <Card className="overflow-hidden">
            <Tabs defaultValue="items" className="w-full">
              <UnderlinedTabsList tabs={tabs} className="px-2" />

              <TabsContent value="items" className="mt-0">
                <OrderItemsTable order={order} loading={loading} actions={actions} isEditable={isEditable} />
              </TabsContent>

              <TabsContent value="timeline" className="mt-0">
                <OrderTimeline logs={order.logs.length > 0 ? order.logs : order.order_logs} />
              </TabsContent>
            </Tabs>
          </Card>
        </div>

        <div className="min-w-0 space-y-4">
          <OrderStatusCard
            order={order}
            loading={loading}
            onStatusUpdate={actions.updateStatus}
            refreshOrder={refresh}
          />
          <OrderCustomerInfo order={order} actions={actions} isEditable={isEditable} />
          <OrderShippingAddress order={order} actions={actions} isEditable={isEditable} />
          <OrderPaymentInfo order={order} actions={actions} isEditable={isEditable} loading={loading} />
        </div>
      </div>
    </div>
  )
}
